import Select from 'react-select';
import BreadCrumbs from "../breadCrumbs"
import { retrunAssets } from '../../utils/getAssets';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOurPeopleData } from '../../redux/slice/ourPeoplePage';
import { useEffect, useState } from 'react';
import { MdSearch } from 'react-icons/md';
import { PropTypes } from 'prop-types';
const Banner = ({ ourPeople,search,handleSearch, handleTagSelected }) => {



  

    const handleChange = (e) => {
        handleSearch(e.target.value)

    }

    // const dispatch = useDispatch()
    // useEffect(() => {
    //     dispatch(fetchOurPeopleData("our-people"))
    // }, [dispatch])
    // const state = useSelector(state => state.ourPeople)


    // const ourPeople = state?.data?.properties

    const name = ourPeople?.pageTitle
    const img = ourPeople?.backgroundImage !== null ? ourPeople?.backgroundImage[0]?.url : ""
    const tags = ourPeople?.searchTags?.items != null ?
        ourPeople?.searchTags?.items?.map(item =>
            item?.content?.properties?.tags !== null ? item?.content?.properties?.tags : ""
        ).flat() : ""
    const options = tags != "" ? tags?.filter(itemTag => itemTag !== 'UNITEN International Advisory Council' && itemTag !== 'ad')
    .map(tag => (
        { value: tag, label: tag })) 
        : null
  

    return (

        <div className="relative h-[60vh] md:h-[70vh]  bg-center   bg-cover   bg-no-repeat" style={{ backgroundImage: `url('${retrunAssets(img)}')` }}>
            <div className="absolute inset-0  bg-[rgba(0,0,0,0.2)] "></div>
            <div className="absolute top-1/2 w-full gap-3 flex flex-col justify-center items-center left-1/2 z-10 -translate-x-1/2 transition-all">
                <h1 className="text-3xl md:text-5xl lg:text-[4rem] whitespace-nowrap font-bold text-white transition-all">{name}</h1>
                <BreadCrumbs />
                {
                    options &&
                    <div className=" max-w-7xl mt-10 flex relative  bg-white rounded-2xl  w-11/12 ">
                        <Select
                            options={
                                options
                            }
                            defaultValue={options ? options[0] : null}
                            onChange={e => e && handleTagSelected(e.value)}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    border: "0",
                                    outline: "none",
                                    boxShadow: "none",

                                }),
                                

                            }}
                            className={`border-0 outline-none  w-full max-w-sm focus:outline-none  p-4 font-bold`} />
                        <div className="flex items-center mr-4  w-full">
                            <input type="text" placeholder="Search" className="outline-none border-0 w-full px-4" value={search} onChange={handleChange} />
                            <MdSearch className="2xl:w-8 2xl:h-8" />
                        </div>

                    </div>
                }
            </div>

        </div >

    )
}
Banner.propTypes = {
    handleTagSelected: PropTypes.func,
    ourPeople: PropTypes.any
}
export default Banner